import { render, staticRenderFns } from "./AnnotationPlugin.vue?vue&type=template&id=5999cf98&scoped=true"
import script from "./AnnotationPlugin.vue?vue&type=script&lang=ts"
export * from "./AnnotationPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./AnnotationPlugin.vue?vue&type=style&index=0&id=5999cf98&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5999cf98",
  null
  ,true
)

export default component.exports